import React from "react"
import {makeStyles} from "@material-ui/core"

// Components
import Header from "../Header"

const useStyles = makeStyles({
    main: {
        minHeight: "calc(100vh - 64px)",
    },
});

/**
 * @param props
 */
export default function Layout(props: React.ComponentProps<any>) {
    const styles = useStyles();

    return (
        <React.Fragment>
            <Header/>
            <main className={styles.main}>
                {props.children}
            </main>
        </React.Fragment>
    )
}
